"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lineDataMapper = exports.findAnnotationForPoint = exports.parseDomain = exports.getDelaunays = exports.getDelaunayData = exports.getHoverPoint = void 0;
const d3 = __importStar(require("d3"));
const utilities_1 = require("../../utilities");
const colors_1 = require("../../utilities/colors");
const constants_1 = require("../../utilities/constants");
const date_1 = require("../../utilities/date");
const getHoverIndex = function () {
  let hoverDatum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let lineData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const simplifiedHoverDatum = {
    x: hoverDatum.x,
    y: hoverDatum.y
  };
  const indexArray = lineData.map(_ref => {
    let {
      data
    } = _ref;
    return data.findIndex(point => point.x === simplifiedHoverDatum.x && point.y === simplifiedHoverDatum.y);
  });
  const subIndex = indexArray.findIndex(index => index !== -1);
  return [subIndex, indexArray[subIndex]];
};
const getHoverDatum = (hoverStyle, delaunays, mouseX, mouseY) => {
  const delaunay = delaunays[hoverStyle];
  const index = delaunay.find(mouseX, mouseY);
  const hoverDatum = delaunays.points[index];
  return hoverDatum;
};
const getDirectionIfInRange = (hoverDatum, mouseX, mouseY, xScale, yScale) => {
  const xDiff = mouseX - xScale(hoverDatum.x);
  const yDiff = mouseY - yScale(hoverDatum.y);
  if (Math.sqrt(xDiff ** 2 + yDiff ** 2) <= constants_1.MAX_HOVER_DISTANCE) {
    const direction = yDiff > 0 ? 'above' : 'below';
    return direction;
  }
  return null;
};
const getClosestDatumOnLine = (hoverDatum, lineData, selectedLineNumber, delaunays, xScale) => {
  const selectedLineId = lineData[selectedLineNumber].id;
  const validData = delaunays.points.map((datum, i) => ({
    ...datum,
    index: i
  })).filter(_ref2 => {
    let {
      id
    } = _ref2;
    return id === selectedLineId;
  });
  const hoverX = xScale(hoverDatum.x);
  const xDifferences = validData.map(_ref3 => {
    let {
      x
    } = _ref3;
    return Math.abs(xScale(x) - hoverX);
  });
  const closestValidIndex = validData[xDifferences.indexOf(Math.min(...xDifferences))].index;
  const closestValidPoint = delaunays.points[closestValidIndex];
  return closestValidPoint;
};
const getHoverPoint = function (data, lineData, delaunays, mouseX, mouseY, xScale, yScale) {
  let selectedLines = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  const hoverStyle = selectedLines.length === 0 && data.length > 1 ? '2d' : 'x';
  let hoverDatum = getHoverDatum(hoverStyle, delaunays, mouseX, mouseY, lineData);
  if (hoverStyle !== '2d') {
    const selectedLineNumber = lineData.findIndex(_ref4 => {
      let {
        id
      } = _ref4;
      return selectedLines.includes(id);
    });
    if (selectedLineNumber !== -1) {
      hoverDatum = getClosestDatumOnLine(hoverDatum, lineData, selectedLineNumber, delaunays, xScale);
    }
  }
  if (!hoverDatum) {
    return null;
  }
  const direction = getDirectionIfInRange(hoverDatum, mouseX, mouseY, xScale, yScale);
  if (hoverStyle !== '2d' || direction) {
    const position = getHoverIndex(hoverDatum, lineData);
    const line = data.find(d => d.id === lineData[position[0]].id);
    return {
      datum: hoverDatum,
      line,
      direction,
      lineNum: position[0]
    };
  }
  return null;
};
exports.getHoverPoint = getHoverPoint;
const getDelaunayData = (lineData, xType) => lineData.map(_ref5 => {
  let {
    data,
    id,
    customDomain
  } = _ref5;
  return data.filter(_ref6 => {
    let {
      x
    } = _ref6;
    if ((0, date_1.isDateType)(xType)) {
      var _customDomain$, _customDomain$$getTim, _customDomain$2, _customDomain$2$getTi;
      const time = x.getTime();
      return time >= (customDomain === null || customDomain === void 0 ? void 0 : (_customDomain$ = customDomain[0]) === null || _customDomain$ === void 0 ? void 0 : (_customDomain$$getTim = _customDomain$.getTime) === null || _customDomain$$getTim === void 0 ? void 0 : _customDomain$$getTim.call(_customDomain$)) && time <= (customDomain === null || customDomain === void 0 ? void 0 : (_customDomain$2 = customDomain[1]) === null || _customDomain$2 === void 0 ? void 0 : (_customDomain$2$getTi = _customDomain$2.getTime) === null || _customDomain$2$getTi === void 0 ? void 0 : _customDomain$2$getTi.call(_customDomain$2));
    }
    return x >= customDomain[0] && x <= customDomain[1];
  }).map(_ref7 => {
    let {
      x,
      y,
      key
    } = _ref7;
    return {
      x,
      y,
      id,
      key
    };
  });
}).flat();
exports.getDelaunayData = getDelaunayData;
const getDelaunays = (points, xScale, yScale) => {
  const scaledPoints = points.map(d => [xScale(d.x), yScale(d.y)]);
  return {
    '2d': d3.Delaunay.from(scaledPoints),
    x: d3.Delaunay.from(scaledPoints.map(_ref8 => {
      let [x] = _ref8;
      return [x, 0];
    })),
    points
  };
};
exports.getDelaunays = getDelaunays;
const parseDomain = (domainToParse, currentDomain, type) => {
  if (!domainToParse || !Array.isArray(domainToParse)) {
    return currentDomain;
  }
  let parsedDomain = [...domainToParse];
  if ((0, date_1.isDateType)(type) && parsedDomain.every(i => i === undefined || !Number.isNaN(parseFloat(Date.parse(i))))) {
    parsedDomain = parsedDomain.map(bound => bound ? (0, date_1.dateParser)(bound, type) : null);
  }
  if (parsedDomain.some(i => Number.isNaN(parseFloat(i)))) {
    return currentDomain;
  }
  return [parsedDomain[0] || currentDomain[0], parsedDomain[1] || currentDomain[1]];
};
exports.parseDomain = parseDomain;
function findAnnotationForPoint(point, annotationData) {
  if (!point) {
    return point;
  }
  const annotation = annotationData.find(i => {
    if (i.x instanceof Date && point.datum.x instanceof Date) {
      return i.x.getTime() === point.datum.x.getTime() && i.y === point.datum.y;
    }
    return i.x === point.datum.x && i.y === point.datum.y;
  });
  return {
    ...point,
    annotation
  };
}
exports.findAnnotationForPoint = findAnnotationForPoint;
const lineDataMapper = (metrics, xDomain, defaults) => (_ref9, i) => {
  let {
    id,
    name,
    x_type: xType,
    data = []
  } = _ref9;
  const {
    color: optionColor,
    displayRangeMax,
    displayRangeMin,
    endMarker,
    fontSize,
    labelText,
    lineStyle,
    lineWeight,
    markerColor: rawMarkerColor,
    markerWeight: rawMarkerWeight,
    tooltipTitle
  } = {
    ...defaults,
    ...metrics.find(_ref10 => {
      let {
        id: dataID
      } = _ref10;
      return dataID === id;
    })
  };
  const parsedData = data.map(_ref11 => {
    let {
      key,
      value
    } = _ref11;
    return {
      x: (0, date_1.dateParser)(key, xType),
      y: value,
      key
    };
  }).filter(_ref12 => {
    let {
      x
    } = _ref12;
    if ((0, date_1.isDateType)(xType)) {
      var _xDomain$, _xDomain$$getTime, _xDomain$2, _xDomain$2$getTime;
      const time = x.getTime();
      return time >= (xDomain === null || xDomain === void 0 ? void 0 : (_xDomain$ = xDomain[0]) === null || _xDomain$ === void 0 ? void 0 : (_xDomain$$getTime = _xDomain$.getTime) === null || _xDomain$$getTime === void 0 ? void 0 : _xDomain$$getTime.call(_xDomain$)) && time <= (xDomain === null || xDomain === void 0 ? void 0 : (_xDomain$2 = xDomain[1]) === null || _xDomain$2 === void 0 ? void 0 : (_xDomain$2$getTime = _xDomain$2.getTime) === null || _xDomain$2$getTime === void 0 ? void 0 : _xDomain$2$getTime.call(_xDomain$2));
    }
    return x >= xDomain[0] && x <= xDomain[1];
  });
  const color = (0, colors_1.parseColor)(optionColor, colors_1.DEFAULT_COLORS[i]);
  const markerColor = (0, colors_1.mapColors)(parsedData, rawMarkerColor, color);
  const markerWeight = rawMarkerWeight || lineWeight * 1.3;
  const customMin = displayRangeMin && (0, date_1.isDateType)(xType) ? (0, date_1.dateParser)(displayRangeMin, xType) : displayRangeMin;
  const customMax = displayRangeMax && (0, date_1.isDateType)(xType) ? (0, date_1.dateParser)(displayRangeMax, xType) : displayRangeMax;
  const customDomain = (0, utilities_1.calculateScale)(xType, [customMin || xDomain[0], customMax || xDomain[1]]).domain();
  return {
    color,
    customDomain,
    data: parsedData,
    endMarker,
    fontSize,
    id,
    labelText,
    lineStyle,
    lineWeight,
    markerColor,
    markerWeight,
    name,
    tooltipTitle
  };
};
exports.lineDataMapper = lineDataMapper;